var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-card',{attrs:{"md-with-hover":""}},[_c('md-ripple',[_c('md-card-actions',[_c('md-button',{attrs:{"to":_vm.toRoute,"md-icon":_vm.mdIcon}},[_vm._v(_vm._s(_vm.name))])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }